import { track } from 'modules/core/lib/Tracking'

import { PendingStatuses } from 'modules/cost_centers/components/CostCentersStructure/types'
import { CostCenterConfigurations } from 'modules/cost_centers/lib/types'

interface Properties {
  [key: string]: string | null | undefined | number
}

interface CostCenterTracking {
  name: string
  status?: string
  legalEntity?: { id: string | number; legalName?: string | null } | null
  code?: string | null | undefined
}

export const trackCostCenterAction = (
  action: string,
  costCenter?: CostCenterTracking | undefined,
  status = ''
) => {
  let properties: Properties = {}
  if (costCenter) {
    const legalEntity = costCenter.legalEntity ? 'Single legal entity' : 'All legal entities'

    properties = {
      costcenter_name: costCenter.name,
      costcenter_legalentity: legalEntity,
      costcenter_code: costCenter.code,
    }
    if (status.length > 0) properties.status = status
  }
  track(action, properties)
}

export const hasCostCenterConfigurationPending = (configurations: CostCenterConfigurations) => {
  return !!configurations?.find(({ processingStatus }) => {
    return PendingStatuses.includes(processingStatus)
  })
}
